/**
 * HUB-3b-1: fetch latest done angles/3d stage + outputs for a style.
 */

import { DEFAULT_STUDIO_ORG_KEY } from "@/lib/shoeStudioPrefs";
import { apiFetch } from "@/lib/apiFetch";

export type StyleStage = "angles" | "3d" | "orbit";

export type StyleStageOutput = {
  kind: string;
  url: string;
};

export type StyleStageJob = {
  id: string;
  pipeline: string;
  status: string;
  created_at: string;
  /** Slim audit envelope from /api/style-stage (optional; not the full jobs.payload). */
  vision_audit_result?: unknown;
  /** Per-view angle identity audits (optional; 2d_angles only). */
  angle_vision_audits?: unknown;
};

export type StyleStageResponse = {
  ok: true;
  stage: StyleStage;
  style_id: string;
  job: StyleStageJob | null;
  outputs: StyleStageOutput[];
  parent_job_id: string | null;
};

export async function fetchStyleStage(
  styleId: string,
  stage: StyleStage,
  orgKey: string = DEFAULT_STUDIO_ORG_KEY,
  /** MV-SCOPE: when set (angles stage), server returns that parent's newest job only. */
  parentJobId?: string | null,
): Promise<StyleStageResponse | null> {
  try {
    const params = new URLSearchParams({
      style_id: styleId,
      stage,
      org_key: orgKey,
    });
    if (
      stage === "angles" &&
      typeof parentJobId === "string" &&
      parentJobId.trim()
    ) {
      params.set("parent_job_id", parentJobId.trim());
    }
    const res = await apiFetch(`/api/style-stage?${params.toString()}`);
    const data = await res.json();
    if (!data?.ok) return null;
    return data as StyleStageResponse;
  } catch {
    return null;
  }
}
